const CountryCodes: Record<string, string> = {
  Albania: 'al',
  Andorra: 'ad',
  Argentina: 'ar',
  Armenia: 'am',
  Austria: 'at',
  Belgium: 'be',
  Bolivia: 'bo',
  'Bosnia and Herzegovina': 'ba',
  Brazil: 'br',
  Bulgaria: 'bg',
  Canada: 'ca',
  Chile: 'cl',
  Colombia: 'co',
  'Costa Rica': 'cr',
  Croatia: 'hr',
  Cuba: 'cu',
  Cyprus: 'cy',
  'Czech Republic': 'cz',
  Czechia: 'cz',
  Denmark: 'dk',
  'Dominican Republic': 'do',
  Ecuador: 'ec',
  Egypt: 'eg',
  'El Salvador': 'sv',
  Estonia: 'ee',
  Europe: 'eu',
  Finland: 'fi',
  France: 'fr',
  Georgia: 'ge',
  Germany: 'de',
  Greece: 'gr',
  Guatemala: 'gt',
  Honduras: 'hn',
  Hungary: 'hu',
  Iceland: 'is',
  India: 'in',
  Ireland: 'ie',
  Italy: 'it',
  Kazakhstan: 'kz',
  Kenia: 'ke',
  Kenya: 'ke',
  Latvia: 'lv',
  Liechtenstein: 'li',
  Lithuania: 'lt',
  Luxembourg: 'lu',
  Malta: 'mt',
  Mexico: 'mx',
  Moldova: 'md',
  Monaco: 'mc',
  Montenegro: 'me',
  Netherlands: 'nl',
  Nicaragua: 'ni',
  'North Macedonia': 'mk',
  Norway: 'no',
  Panama: 'pa',
  Paraguay: 'py',
  Peru: 'pe',
  Poland: 'pl',
  Portugal: 'pt',
  Romania: 'ro',
  Russia: 'ru',
  'San Marino': 'sm',
  Serbia: 'rs',
  Slovakia: 'sk',
  Slovenia: 'si',
  Spain: 'es',
  Sweden: 'se',
  Switzerland: 'ch',
  USA: 'us',
  Ukraine: 'ua',
  'United Kingdom': 'gb',
  'United States': 'us',
  'United States of America': 'us',
  Uruguay: 'uy',
  Uzbekistan: 'uz',
  Venezuela: 've',
};

export const getCountryCode = (icon: string) => CountryCodes[icon] ?? null;
